<div class="app-l-page-wrap">
    <page-loader *ngIf="!isLoaded"></page-loader>
    <div id="courses-listing-page">
        <div class="app-l-page__navigation" *ngIf="isLoaded">
            <div class="app-l-page__previous">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                    aria-label="Go to previous page"
                    (click)="goBack()"
                    (keypress)="goBack()">
                    <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav
                aria-label="Breadcrumb"
                class="app-l-page__breadcrumbs"
                *ngIf="showBreadcrumbs">
                <ul>
                    <li class="breadcrumbs-list-item">
                        <a
                            translate
                            [routerLink]="['/app/series']"
                            (click)="gotoCourses()"
                            aria-label="Go to Series"
                            tabindex="0">
                            series.title
                        </a>
                    </li>
                    <li class="breadcrumbs-list-item" *ngIf="!isOrgContent">
                        <a
                            translate
                            [routerLink]="['/app/series/video']"
                            aria-label="Go to Video Series"
                            tabindex="0">
                            series.seriesTypes.video
                        </a>
                    </li>
                    <li class="breadcrumbs-list-item" *ngIf="isOrgContent">
                        <a
                            [routerLink]="['/app/series/org-series-contents']"
                            translate
                            aria-current="false">
                            {{ organizationOwnContentTitle }}
                        </a>
                    </li>
                    <li
                        class="app-l-current-page"
                        aria-current="page"
                        tabindex="0">
                        {{ title }}
                    </li>
                </ul>
            </nav>
        </div>
        <!-- <page-header class="d-n" [headerText]="title" [backLink]="backLink" [cssClass]='cssModule'
            [backText]="backText"></page-header> -->

        <div class="" *ngIf="isLoaded">
            <div class="app-l-page-header-block">
                <div class="app-l-page-title-block">
                    <h1 id="section-title" class="app-l-page-title" translate>
                        {{ title }}
                    </h1>
                    <span class="app-l-course__total"
                        >(<span translate
                            >theory.total<span>{{
                                courseVideos.length
                            }}</span></span
                        >)</span
                    >
                </div>
                <div
                    class="card-footer row align-items-center"
                    *ngIf="showConnect()"
                    style="margin-top: 15px">
                    <div class="col">
                        <span
                            class="link"
                            aria-label="connect"
                            translate
                            style="font-size: 14px">
                            Looking to connect with a counselor or psychiatrist?
                            Check out
                        </span>
                    </div>
                    <div class="col-auto">
                        <a
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            aria-label="Welltrack Connect"
                            href="https://welltrack-connect.com/"
                            target="_blank"
                            ><span translate
                                >theory.welltrackConnectHeading</span
                            ></a
                        >
                    </div>
                </div>
            </div>
            <page-loader *ngIf="!isLoaded"></page-loader>
            <div class="app-l-course__q-base">
                <div class="app-l-course__q-list">
                    <div
                        class="app-l-course__q-block"
                        [attr.aria-label]="video.label + ' Video'"
                        *ngFor="let video of courseVideos">
                        <div
                            class="app-lcourse__q-image"
                            (click)="gotoVideo(video.id, 1)"
                            (keypress)="gotoVideo(video.id, 1)">
                            <img
                                [defaultImage]="'./assets/img/course_image_default.svg'"
                                [lazyLoad]="video.image"
                                [alt]="
                                    'a11y.videoThumbnail'
                                        | translate: { name: video.label }
                                " />
                            <button
                                class="app-l-course__play"
                                [attr.aria-label]="'Play ' + video.label"
                                (click)="gotoVideo(video.id, 1)"
                                (keypress)="gotoVideo(video.id, 1)">
                                <svg-icon
                                    icon="play"
                                    class="w-100 h-100"></svg-icon>
                            </button>
                            <div translate class="app-l-course__video-status">
                                <div
                                    *ngIf="
                                        video.courseProgress.Status ===
                                        'inprogress'
                                    "
                                    class="app-l-course__badge app-l-course__badge-inprogress">
                                    <svg-icon
                                        icon="timer"
                                        class="app-l-course__badge-icon"
                                        alt="timer"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.inProgress</span
                                    >
                                </div>
                                <div
                                    *ngIf="
                                        video.courseProgress.Status ===
                                        'completed'
                                    "
                                    class="app-l-course__badge app-l-course__badge-completed">
                                    <svg-icon
                                        icon="tick-circle"
                                        class="app-l-course__badge-icon"
                                        alt="completed"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.completed</span
                                    >
                                </div>
                            </div>
                            <div class="app-l-course__video-length">
                                <span translate
                                    >theory.length
                                    <span class="app-l-length__duration">{{
                                        video.length
                                    }}</span>
                                </span>
                            </div>
                        </div>
                        <div
                            class="app-l-course__q-body"
                            (click)="gotoVideo(video.id, 0)"
                            (keypress)="gotoVideo(video.id, 0)">
                            <h2>{{ video.label }}</h2>
                            <!-- <a class="rate-video" (click)="onRateItem()"><i class="fa fa-star" aria-hidden="true"></i> Rate
                                video.</a> -->
                            <div
                                class="app-l-course__q-description"
                                *ngIf="video.description"
                                [innerHtml]="video.description"></div>
                        </div>
                        <div
                            class="app-l-course__q-footer"
                            (click)="gotoVideo(video.id, 0)"
                            (keypress)="gotoVideo(video.id, 0)">
                            <div class="app-l-course__f-left">
                                <button
                                    [attr.aria-label]="
                                        'View more about ' +
                                        video.label +
                                        ' video'
                                    "
                                    class="app-c-btn app-c-btn--text-primary app-c-btn--text app-c-btn--text-with-icon">
                                    <span translate>theory.viewMore</span>
                                    <svg-icon
                                        icon="angle-right"
                                        alt="viewMore"></svg-icon>
                                </button>
                            </div>
                            <div class="app-l-course__f-right">
                                <button
                                    translate
                                    *ngIf="video?.links?.length"
                                    [attr.aria-label]="
                                        'Go to Link of ' +
                                        video.label +
                                        ' video'
                                    "
                                    class="app-c-btn app-c-btn--icon app-c-btn--icon-primary app-c-btn--icon-16">
                                    <svg-icon
                                        icon="book"
                                        class="w-100 h-100"
                                        alt="book"></svg-icon>
                                </button>
                                <button
                                    translate
                                    *ngIf="video?.attachments?.length"
                                    [attr.aria-label]="
                                        'Download Attachments of ' +
                                        video.label +
                                        ' video'
                                    "
                                    class="app-c-btn app-c-btn--icon app-c-btn--icon-primary app-c-btn--icon-16">
                                    <svg-icon
                                        icon="download"
                                        class="w-100 h-100"
                                        alt="download"></svg-icon>
                                </button>
                                <button
                                    translate
                                    *ngIf="video.moodcheckLink"
                                    aria-label="Go to Moodcheck"
                                    class="app-c-btn app-c-btn--icon app-c-btn--icon-primary app-c-btn--icon-16">
                                    <svg-icon
                                        icon="emoji"
                                        class="w-100 h-100"
                                        alt="emoji"></svg-icon>
                                </button>
                            </div>
                        </div>
                        <!-- <div class="card-footer row justify-content-end" *ngIf="showConnect()">
                            <div class="col"></div>
                            <div class="col-auto">
                                <span class="link" aria-label="connect" translate>
                                    <hr />
                                    theory.courses.welltrackConnect<br />
                                    <a
                                        class="btn btn-primary btn-inline"
                                        aria-label="Welltrack Connect"
                                        href="https://welltrack-connect.com/"
                                        target="_blank"
                                        translate
                                        >theory.welltrackConnectHeading</a
                                    >
                                </span>
                            </div>
                        </div> -->
                    </div>
                </div>

                <div
                    class="talk-about card-container"
                    *ngIf="ssoLink && talkAboutLink">
                    <div class="card">
                        <img
                            class="together-all-logo"
                            alt="Logo"
                            src="./assets/img/additional-resources/togetherall.svg" />
                        <div>
                            <h2>Discussion Forum on {{ moduleTitle }}</h2>
                            <div
                                class="talk-about-link"
                                [innerHtml]="talkAboutDescription"></div>
                            <a
                                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                aria-label="description"
                                (click)="onTalkAboutLink(talkAboutLink)"
                                (keypress)="onTalkAboutLink(talkAboutLink)"
                                ><span translate>theory.gotoDiscussion</span></a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
